import { css } from "@emotion/css";
import { Tooltip } from "@octopusdeploy/design-system-components";
import { EqualsIcon } from "@octopusdeploy/design-system-icons";
import { borderRadius, themeTokens } from "@octopusdeploy/design-system-tokens";
export function RunInParallelIndicator() {
    return (<Tooltip className={parallelIconStyles} display="flex" content={"Runs in parallel"}>
            <EqualsIcon size={16} color={themeTokens.color.parallelChip.icon}/>
        </Tooltip>);
}
const parallelIconStyles = css({
    zIndex: 1,
    position: "absolute",
    top: "-0.875rem",
    left: "-0.4rem",
    borderRadius: borderRadius.circle,
    width: "1.25rem",
    height: "1.25rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: themeTokens.color.parallelChip.background,
});
